module.exports = __webpack_public_path__ + "img/logo_mb.90a8892f.svg";